module.exports = __webpack_public_path__ + "img/4.c4ac1ec7.png";